import React, { useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import Alerts from "../../../helper/Alert";
import ApplicantDetails from "./ApplicantDetails";
import ProjectDetails from "./ProjectDetails";
import AcknowledgementandDeclaration from "./AcknowledgementandDeclaration";
import ReviewAndSubmit from "./Review";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import VisibilityIcon from "@mui/icons-material/Visibility";
import OrganizationDetails from "./OrgDetails";
const steps = [
  "Applicant Details",
  "organization Details",
  "Project Details",

  "Acknowledgement and Declaration",
  "Review and Submit",
];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    background:
      "linear-gradient(136deg, rgb(242,113,33), rgb(233,64,87), rgb(138,35,135))",
    boxShadow: "0 4px 10px rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    background:
      "linear-gradient(136deg, rgb(242,113,33), rgb(233,64,87), rgb(138,35,135))",
  }),
}));

const ColorlibStepIcon = (props) => {
  const { active, completed, icon } = props;
  const icons = {
    1: <PersonOutlineOutlinedIcon />,
    2: <CorporateFareIcon />,
    3: <WorkHistoryIcon />,
    4: <LocalLibraryIcon />,
    5: <VisibilityIcon />,
  };
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }}>
      {icons[icon]}
    </ColorlibStepIconRoot>
  );
};

export default function DevelopmentApply() {
  const [activeStep, setActiveStep] = useState(0);
  const [files, setFiles] = useState([]);
  const [alert, setAlert] = React.useState({
    open: false,
    message: "",
    severity: "",
  });
  const handleCloseAlert = () => {
    setAlert({
      open: false,
      message: "",
      severity: "",
    });
  };

  const [getData, setGetData] = useState({});
  console.log("getData Value", getData);
  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <ApplicantDetails
            handleNext={handleNext}
            setGetValues={setGetData}
            getValues={getData}
          />
        );
      case 1:
        return (
          <OrganizationDetails
            handleBack={handleBack}
            handleNext={handleNext}
            setGetValues={setGetData}
            getValues={getData}
          />
        );
      case 2:
        return (
          <ProjectDetails
            handleBack={handleBack}
            handleNext={handleNext}
            setGetValues={setGetData}
            getValues={getData}
            setFiles={setFiles}
            files={files}
            setAlert={setAlert}
          />
        );

      case 3:
        return (
          <AcknowledgementandDeclaration
            handleBack={handleBack}
            handleNext={handleNext}
            setGetValues={setGetData}
            getValues={getData}
            setAlert={setAlert}
          />
        );
      case 4:
        return (
          <ReviewAndSubmit
            handleBack={handleBack}
            handleNext={handleNext}
            getValues={getData}
            setAlert={setAlert}
            files={files}
          />
        );

      default:
        return <Typography>Unknown step</Typography>;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 7,
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Alerts
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={handleCloseAlert}
      />

      <Box sx={{ width: "80%" }}>
        {" "}
        {/* Set maxWidth for centering */}
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
          sx={{ mx: "auto" }}
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <Box sx={{ width: "100%", mt: 4, textAlign: "center" }}>
          {activeStep === steps.length ? (
            <>
              <Typography>All steps completed - you're finished</Typography>
              <Button onClick={handleReset} sx={{ mt: 2 }}>
                Reset
              </Button>
            </>
          ) : (
            <>
              <Box sx={{ maxWidth: "70%vw" }}>{getStepContent(activeStep)}</Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
